module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "open"
  }, [_vm._v(_vm._s(_vm.openName))]), _vm._v(" "), _c('span', {
    staticClass: "close"
  }, [_vm._v(_vm._s(_vm.closeName))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-14b0f39c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14b0f39c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/switch.vue
// module id = 714
// module chunks = 0